<section>
    <div class="main-content">
     
        <div class="logo-container">
            <h1>Welcome to</h1>
            <img src="../../../assets/img/3-ez-docs-powered-by.png" alt="EZ DOCS LOGO" />
        </div>
        <div class="welcome-text">
           
            <div class="btn-wrap">
                <button class="login-btn" matButton id="login" [routerLink]="['/welcome', 'setup']">Continue</button>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</section>
